module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step1b_Image10.3f88fc05.jpg";